export default __webpack_public_path__ + "static/media/lebensborn_black_1000.4936d89c.png";